<template>
    <Modal @close="handleClose">
        <div>
            <p>Your practice has enabled invoices to be auto-generated for clients in attendance at appointments. Please confirm client is present before updating attendance.</p>

            <div class="align-right top-20">
                <button
                    class="secondary cancel"
                    @click="handleCancel"
                >
                    Cancel
                </button>
                <button
                    class="primary"
                    @click="handleAccept"
                >
                    Accept
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
    import { mapState } from 'vuex';
    import Modal from '@/components/general/modals/Modal';
    import { checkAutopay } from '@/components/calendar/AppointmentEditor/common/api';
    import { appts } from '@/util/apiRequests';
    import { AttendanceStatus } from '@/components/calendar/AppointmentEditor/common/constants';

    export default {
        name: 'AutoGenInvoiceModal',
        components: { Modal },
        computed: {
            ...mapState('eventEditor', {
                client: (state) => state.modals.autoGenInvoice.selectedClient,
                clients: (state) => state.event.clients,
                previousAttendance: (state) => state.modals.autoGenInvoice.previousAttendance,
                event: (state) => state.event,
            }),
            clientHasInvoice() {
                return Boolean(this.client.invoice_id);
            }
        },
        methods: {
            handleClose() {
                this.$store.commit('eventEditor/closeModal', 'autoGenInvoice');
            },
            handleCancel() {
                this.$store.dispatch('eventEditor/resetAttendance', {
                    clientId: this.client.id,
                    previousAttendance: this.previousAttendance
                });

                this.handleClose();
            },
            resetAttendance() {
                this.$store.dispatch('eventEditor/resetAttendance', {
                    clientId: this.client.id,
                    previousAttendance: this.client.appt_status
                });
            },
            async handleAccept() {
                let paymentDetail = {};

                if (!this.clientHasInvoice) {
                    paymentDetail.autopay = await checkAutopay(this.client.id);
                    paymentDetail.apptGroupUuid = this.event.group_uuid;
                    paymentDetail.invoices = [{
                        invoice: {
                            office_id: this.event.office_id,
                            company_id: this.event.company_id,
                            client_id: this.client.id,
                        },
                        progressNote: {
                            id: this.client.pn_id,
                            apptId: this.client.appt_id,
                        },
                        services: this.client.services.map((s) => s.serviceCodeId),
                    }];
                }

                try {
                    const res = await this.$api.patch(appts.updateApptStatus(this.client.appt_id), {
                        status: AttendanceStatus.Attended,
                        addCancelFee: false,
                        pageId: this.pageMeta.id,
                        generateInvoice: true,
                        paymentDetail,
                    });

                    if (res.status >= 300 || res.status < 200) {
                        return this.resetAttendance();
                    }

                    if (this.autoGenerateInvoices && this.clientHasInvoice) {
                        this.$toasted.error('Invoice has already been generated for this appointment.');
                    } else {
                        this.$toasted.success('Updated appointment status');
                    }

                    await this.$store.dispatch('eventEditor/updateAttendance', {
                        clientId: this.client.id,
                        nextAttendance: AttendanceStatus.Attended,
                    });

                    this.$emit('refresh');
                    this.handleClose();
                } catch (err) {
                    this.resetAttendance();
                    this.handleClose();
                }
            }
        }
    };
</script>

<style scoped>

</style>